import React, { useState, useRef, useEffect } from "react";
import Card from "react-bootstrap/Card";
import { CardGroup } from "react-bootstrap";
import "./style.css";
import { useLocation, useNavigate } from "react-router-dom";
import { images } from "../../../../constants";
import { useSelector } from "react-redux";
import Skeleton from "@mui/material/Skeleton";

export default function BoxData({
  imgg,
  Title,
  Butonn,
  url,
  link,
  ms,
  buy,
  handleShow,
  cvform,
}) {
  const location = useLocation();
  const { name } = useSelector((state) => state.user);
  const [imgLoading, setImgLoading] = useState(true);
  const imgRef = useRef(null);

  useEffect(() => {
    if (imgRef.current && imgRef.current.complete) {
      setImgLoading(false);
    }
  }, []);

  if (Butonn === "Check Now") {
    link = ""
  }
  else {
    link = link
  }

  const navigate = useNavigate();
  return (
    <div>
      <CardGroup className="width-box">
        <Card
          className={`${link === "/user-dashboard" || link === "/user-profile"
            ? ""
            : "Main-card"
            }`}
        >
          <div
            className={`${link === "/user-profile" ? "" : "mt-3"
              } card-second-div`}
            style={{ position: "relative" }}
          >
            {imgLoading && (
              <Skeleton 
                variant="circular" 
                width={70} 
                height={70} 
                className="mt-1"
                sx={{ mb: 1 }}
              />
            )}
            <Card.Img
              ref={imgRef}
              className={`card-img dashboard_card mt-1 ${link === "/user-profile" ? "dashboard_card_r" : ""
                }`}
              src={imgg}
              style={{ display: imgLoading ? 'none' : 'block' }}
              onLoad={() => setImgLoading(false)}
              onError={(e) => {
                setImgLoading(false);
                if (e.target.src !== images.noprofile) {
                  e.target.src = images.noprofile;
                }
              }}
            />
            
            {imgLoading ? (
              <Card.Body className="p-2 w-100">
                <div className="d-flex justify-content-center mb-1">
                  <Skeleton variant="text" width="70%" height={20} />
                </div>
                <div className="d-flex justify-content-center mt-2">
                   <Skeleton variant="rounded" width="80px" height={28} sx={{ borderRadius: "20px" }} />
                </div>
              </Card.Body>
            ) : (
              <Card.Body className="p-2">
                <Card.Title className="title-size d-flex justify-content-center mb-2">
                  {link === "/user-profile"
                    ? `${name?.fullname || "User Profile"}`
                    : link === "/user-dashboard"
                      ? null
                      : Title}
                </Card.Title>

                {link === "/user-dashboard" || link === "/user-profile" ? (
                  <div className="d-flex justify-content-center">
                    <Card.Text className="verify text-center">
                      <img src={images.Verified} width="18" height="18" alt="verified" />{" "}
                      Verified
                    </Card.Text>
                  </div>
                ) : null}

                {handleShow ? (
                  <button
                    className={`${link === "/user-profile" ? "mt-2" : "mt-1"
                      } btn-clr d-block mx-auto`}
                    onClick={
                      cvform && cvform?.length > 0
                        ? () => navigate("/CV-Form")
                        : handleShow
                    }
                  >
                    {Butonn}
                  </button>
                ) : (
                  <button
                    className={`${link === "/user-dashboard" || link === "/user-profile"
                      ? "btn-clr-plus"
                      : "btn-clr"
                      } d-block mx-auto mt-1`}
                    onClick={() =>
                      navigate(
                        `${location.pathname === "/SellingSide" ? url : link}`
                      )
                    }
                  >
                    {Butonn}
                  </button>
                )}
              </Card.Body>
            )}
          </div>
        </Card>
      </CardGroup>
    </div>
  );
}
